import { isFunction } from '@kirvanobr/shared-utils';

function assignRef(ref, value) {
  if (ref == null)
    return;
  if (isFunction(ref)) {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}

export { assignRef, mergeRefs };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HF4UIUML.mjs.map